module.exports = __webpack_public_path__ + "static/media/edit-1.e192e39e.svg";